import { render } from "./AboutMe.vue?vue&type=template&id=a9898f6a&scoped=true"
import script from "./AboutMe.vue?vue&type=script&lang=js"
export * from "./AboutMe.vue?vue&type=script&lang=js"

import "./AboutMe.vue?vue&type=style&index=0&id=a9898f6a&scoped=true&lang=css"

import exportComponent from "D:\\Learning\\Projects\\allankirui.github.io\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9898f6a"]])

export default __exports__